__webpack_require__.p = "https://newcdn.10masters.com/reactweb/";